import api from '../../config/api_config';

export const labApi = {
    // Laboratories
    getLabs: (params) => api.get('/laboratories/', { params }),
    getLabById: (id) => api.get(`/laboratories/${id}/`),
    createLab: (data) => {
        // Check if data is FormData (for file uploads)
        const config = data instanceof FormData 
            ? { headers: { 'Content-Type': 'multipart/form-data' } }
            : {};
        return api.post('/laboratories/', data, config);
    },
    updateLab: (id, data) => {
        const config = data instanceof FormData 
            ? { headers: { 'Content-Type': 'multipart/form-data' } }
            : {};
        return api.put(`/laboratories/${id}/`, data, config);
    },
    // Cases
    getCases: (params) => api.get('/cases/', { params }),
    getCaseById: (id) => api.get(`/cases/${id}/`),
    createCase: (data) => api.post('/cases/', data),
    updateCase: (id, data) => api.put(`/cases/${id}/`, data),
    
    // Samples
    getSamples: (params) => api.get('/samples/', { params }),
    createSample: (data) => api.post('/samples/', data),
    updateSample: (id, data) => api.put(`/samples/${id}/`, data),
    
    // Results
    addResults: (sampleId, data) => api.post(`/samples/${sampleId}/results/`, data),
    updateResults: (sampleId, resultId, data) => 
        api.put(`/samples/${sampleId}/results/${resultId}/`, data)
};